import { Box, Tab, Tabs } from "@mui/material";

export default function FormulariosTabs({ value, onChange }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={(_, nextValue) => onChange(nextValue)}
        sx={{
          minHeight: 42,
          "& .MuiTab-root": {
            minHeight: 42,
            textTransform: "none",
            fontSize: 13,
            fontWeight: 800,
          },
        }}
      >
        <Tab label="Plantillas" value="plantillas" />
        <Tab label="Solicitudes recibidas" value="solicitudes" />
      </Tabs>
    </Box>
  );
}
